import React, { useCallback } from 'react';

import { IconsEnum } from '../../../../../assets/icons/types';
import { IsDisabled } from '../../../../../types';
import { FetchMaterialsFilterFields } from '../../../../materials/materialsTypes';

import { TextFilter } from '../../../../../helpers/filters/TextFilter';

import { materialsKeys } from '../../../../../locales/keys';

interface ThreeDStockMaterialsSearchFieldProps {
  value?: string;
  onSearch?: (value?: string) => void;
  disabled?: IsDisabled;
}

function ThreeDStockMaterialsSearchField({
  value = '',
  onSearch,
  disabled
}: ThreeDStockMaterialsSearchFieldProps) {
  const handleSearch = useCallback<
    (
      changedFilters: { [name: string]: string },
      removeFilters: string[]
    ) => void
  >(
    ({ name }) => {
      onSearch(name);
    },
    [onSearch]
  );

  return (
    <div className="relative grow flex-1 py-2">
      <TextFilter
        changeOnEnter
        dataGa="three-d-stock-materials-text-filter-input"
        disabled={disabled}
        i18nPlaceholder={materialsKeys.search}
        icon={IconsEnum.SEARCH_OUTLINE}
        iconClassName="stroke-2 h-6 w-6 shrink-0 pointer-events-none"
        iconWrapperClassName="absolute left-4 top-3"
        inputClassName="pl-12 pr-24 flex items-center gap-2 h-full w-full border rounded-full shadow-inner bg-gray-100 border-gray-500 dark:bg-gray-950 dark:border-gray-500 hover:border-gray-900 dark:hover:border-blue-200 focus-within:hover:border-blue-300 focus-within:ring-primary transition-colors duration-150 ease-out"
        className="h-full w-full relative"
        name={FetchMaterialsFilterFields.NAME}
        onChange={handleSearch}
        value={value}
        type="text"
      />
    </div>
  );
}

export default ThreeDStockMaterialsSearchField;
